module.exports = __webpack_public_path__ + "static/media/fivek-en.594c780a.png";